import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/users/login`, { email, password });


      // Check for EITHER 'ok' OR true
      if (res.data.status === 'ok' || res.data.success === true) {
        
        // Debug check
        console.log("User Role:", res.data.user.role);

        if (res.data.user.role !== 'super_admin') {
            setError("Access Denied. You are not an Admin.");
            return;
        }
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('DDoctorUser', JSON.stringify(res.data.user));
        navigate('/admin/dashboard');
      } else {
        // This shows the backend error message
        setError(res.data.message);
      }
    } catch (err) {
      console.error(err);
      setError("Invalid Credentials or Server Error");
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
      <div className="card border-0 shadow-lg" style={{ width: '400px' }}>
        <div className="card-body p-5">
          <div className="text-center mb-4">
             <h3 className="fw-bold text-primary">DDoctor Admin</h3>
             <small className="text-muted">Internal Management System</small>
          </div>
          
          {error && <div className="alert alert-danger small">{error}</div>}

          <form onSubmit={handleLogin}>
            <div className="mb-3">
              <label className="form-label small fw-bold">Admin Email</label>
              <input 
                type="email" 
                className="form-control" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)} 
                required 
              />
            </div>
            <div className="mb-4">
              <label className="form-label small fw-bold">Password</label>
              <input 
                type="password" 
                className="form-control" 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
                required 
              />
            </div>
            <button className="btn btn-primary w-100 fw-bold">Login to Console</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;